import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { OWNER_REPORT_MONTH_PATTERN } from '@repo/shared/marketing';
import { MarketingOwnerReportPage } from '@/features/marketing';

interface OwnerReportSearch {
  month?: string;
}

export const Route = createFileRoute('/_auth/$orgId/marketing/owner-report')({
  validateSearch: (search: Record<string, unknown>): OwnerReportSearch => ({
    month: typeof search.month === 'string' && OWNER_REPORT_MONTH_PATTERN.test(search.month) ? search.month : undefined,
  }),
  component: OwnerReportRoute,
});

function OwnerReportRoute() {
  const { orgId } = Route.useParams();
  const { month } = Route.useSearch();
  const navigate = useNavigate({ from: '/$orgId/marketing/owner-report' });
  return (
    <MarketingOwnerReportPage
      orgId={orgId}
      month={month}
      // A month pick replaces the history entry, so Back leaves the page instead of stepping through months.
      onSelectMonth={(next) => void navigate({ search: { month: next }, replace: true })}
    />
  );
}
